const styles = theme => ({
    grow: {
        flexGrow: 1
    },

    toolbar: {
      borderBottom: `1px solid rgba(0, 0, 0, 0.12)`
    },
  
    menuButton: {
      marginLeft: -12
    },

    buttonsContainer: {
      textAlign: 'left',
      marginTop: theme.spacing()
    },

    previewContainer: {
      paddingLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
        marginTop: theme.spacing(3)
      }
    },

    previewCard: {
      background: '#ffffff',
      borderRadius: '16px',
      border: '1px solid #e0e0e0',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    },

    previewHeader: {
      background: 'linear-gradient(135deg, #0D3559 0%, #1a4b7c 100%)',
      color: '#fff',
      padding: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },

    stepContainer: {
      padding: '24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      position: 'relative'
    },

    stepItem: {
      display: 'flex',
      gap: '16px',
      position: 'relative',
      '&:not(:last-child):after': {
        content: '""',
        position: 'absolute',
        top: '32px',
        left: '15px',
        bottom: '-24px',
        width: '2px',
        backgroundColor: '#e0e0e0'
      }
    },

    stepNumber: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: '#0D3559',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: 'bold',
      flexShrink: 0,
      zIndex: 1
    },

    stepContent: {
      flexGrow: 1
    },

    stepLabel: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#757575',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '8px'
    },

    chatBubble: {
      padding: '12px 16px',
      borderRadius: '12px',
      maxWidth: '85%',
      fontSize: '14px',
      lineHeight: '1.5',
      position: 'relative'
    },

    userBubble: {
      background: '#f1f1f1',
      color: '#333',
      borderTopLeftRadius: 0
    },

    botBubble: {
      background: '#e8eff5',
      color: '#0D3559',
      border: '1px solid #d1dfea',
      borderTopRightRadius: 0
    },

    intentBadge: {
      display: 'inline-block',
      padding: '4px 12px',
      background: '#e3f2fd',
      color: '#1976d2',
      borderRadius: '16px',
      fontSize: '13px',
      fontWeight: '600'
    },

    choiceButton: {
      textTransform: 'none',
      borderRadius: '24px',
      borderColor: '#0D3559',
      color: '#0D3559',
      padding: '4px 16px',
      fontWeight: '600',
      fontSize: '12px',
      '&:hover': {
        background: '#e8eff5',
        borderColor: '#0D3559'
      }
    },


    placeholderText: {
      color: '#bdbdbd',
      fontStyle: 'italic'
    }

  })
  
  export default styles
  